import {AbstractControl, FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
import {Error} from '../model/error';

export class ValidatorUtils {
  static areEquals = (control: AbstractControl): { [key: string]: any } => {
    let notEquals = false;
    let first = true;
    let ref;
    for (const key in control.value) {
      if (first) {
        ref = control.value[key];
        first = false;
      } else if (ref !== control.value[key]) {
        notEquals = true;
      }
    }
    // @ts-ignore
    return notEquals ? {[Error.Type.NOT_EQUALS]: true} : null;
  }

  static areEqualsTo = (to: number, fctToGetValueForSum: (abstractControl: { [key: string]: AbstractControl }) => any) => {
    return (control: FormArray): { [key: string]: any } => {
      let count = 0;
      for (const formGroup of control.controls) {
        count += +fctToGetValueForSum((<FormGroup>formGroup).controls);
      }
      // @ts-ignore
      return (count === to) ? null : {
        [Error.Type.NOT_EQUALS_TO]: true,
        'value': to
      };
    };
  }

  static areNotEquals = (fctToGetValue: (abstractControl: { [key: string]: AbstractControl }) => any[]) => {
    return (control: FormArray): { [key: string]: any } => {
      const values: any[] = control.controls.map(formGroup => fctToGetValue((<FormGroup>formGroup).controls));
      // @ts-ignore
      return values.length === new Set(values).size ? null : {
        [Error.Type.EQUALS]: true
      };
    };
  }

  static requiredIf = (field: string, fctIf: (formGroup: FormGroup) => boolean) => {
    return (formGroup: FormGroup): { [key: string]: any } => {
      // @ts-ignore
      return fctIf(formGroup) && !new FormControl(formGroup.get(field).value, Validators.required).valid ? {
        [Error.Type.REQUIRED_IF]: true,
        'field': field
      } : null;
    };
  }

  static isNumber = (formControl: FormControl): { [key: string]: any } => {
    // @ts-ignore
    return isNaN(Number(formControl.value)) ? {[Error.Type.NOT_A_NUMBER]: true} : null;
  }

  static positive = (formControl: FormControl): { [key: string]: any } => {
    // @ts-ignore
    return (formControl.value == null || formControl.value > 0) ? null : {[Error.Type.POSITIVE]: true};
  }

  static getFormError<T extends FormGroup | FormArray>(formGroup: T, formName: string): Error {
    let error = ValidatorUtils._getFormError(formGroup, formName);
    if (!error) {
      error = ValidatorUtils._getDefaultError([formName]);
    }

    return error;
  }

  private static _getError(type: Error.Type, fields?: string[], values?: any[]): Error {
    const error = new Error();
    if (fields) {
      error.fields = fields;
    }
    if (values) {
      error.values = values;
    }
    error.type = type;

    return error;
  }

  private static _getFormError<T extends FormGroup | FormArray>(formGroup: T, formName?: string): Error {
    let error;

    // Browse all childs
    for (const fieldName in formGroup.controls) {
      if (formGroup.controls.hasOwnProperty(fieldName)) {
        // @ts-ignore
        const formGroupField = formGroup.controls[fieldName];

        if (formGroupField.invalid) {
          if (formGroupField instanceof FormGroup || formGroupField instanceof FormArray) {
            // Keep browsing
            error = ValidatorUtils._getFormError(formGroupField, fieldName);
          } else if (formGroupField instanceof FormControl) {
            // That's a child, get error from that one
            error = ValidatorUtils._getFieldError(formGroupField, fieldName);
          }
          if (error) {
            break;
          }
        }
      }
    }
    // If no error, could be from the parent
    if (!error && formGroup.invalid) {
      error = ValidatorUtils._getFieldError(formGroup, formName);
    }

    // @ts-ignore
    return error;
  }

  // @ts-ignore
  private static _getFieldError(formGroupField, fieldName) {
    let error;
    for (const formError in formGroupField.errors) {
      if (formGroupField.errors.hasOwnProperty(formError)) {
        // @ts-ignore
        const type: Error.Type = Error.getTypeFromNgValidator(formError);
        error = ValidatorUtils._getError(
          type,
          Error.getFieldFromNgValidator(type, fieldName, formGroupField.errors),
          Error.getValueFromNgValidator(type, formGroupField.errors)
        );

        break;
      }
    }

    return error;
  }

  private static _getDefaultError(fields: string[]) {
    let error;
    if (fields && fields.length > 0) {
      error = ValidatorUtils._getError(Error.Type.NOT_VALID_, fields);
    } else {
      error = ValidatorUtils._getError(Error.Type.NOT_VALID_DATA);
    }

    return error;
  }
}
